import React, { useEffect, useState } from "react";
import { Input } from "../../../Helpers/Input/Input";
import trans from "../../../../utils";
import PhoneInput from "react-phone-input-2";
import { Checkbox, Select, Space } from "antd";
import { useSelector } from "react-redux";
import { useGetChildUsersQuery } from "../../../../Redux/service/Users/Users";
import { useGetAllCustomersQuery } from "../../../../Redux/service/Customer/Customer";

export default function POIsContactInfo({ addPOI }) {
	const [actualUsers, setActualUsers] = useState(
		addPOI?.values?.contactPerson?.isCurrentUser || false
	);
	const [user, setUser] = useState();
	const inf = useSelector((state) => state.users.user);
	const { data } = useGetAllCustomersQuery({ page: 1, limit: 10000 });
	console.log("actualUsers ", actualUsers);
	console.log("data ", data);
	useEffect(() => {
		if (
			addPOI?.values?.contactPerson?.isCurrentUser &&
			data?.data?.length > 0
		) {
			// only set if no name/email/phone already filled
			if (!addPOI.values.contactPerson.name) {
				addPOI.setFieldValue("contactPerson.name", data?.data[0]?.name);
				addPOI.setFieldValue("contactPerson.email", data?.data[0]?.email);
				addPOI.setFieldValue("contactPerson.phone", data?.data[0]?.phoneNumber);
				addPOI?.setFieldTouched("contactPerson.phone", true);
				addPOI?.setFieldTouched("contactPerson.name", true);
				addPOI?.setFieldTouched("contactPerson.email", true);
			}
		}
	}, [addPOI?.values?.contactPerson?.isCurrentUser, data?.data]);

	return (
		<>
			<div className="col-lg-12">
				<Input
					title={trans("Client/Customer Name")}
					type="text"
					placeholder={trans("Enter client/customer name")}
					id="clientName"
					name="clientName"
					formstyle="form-input"
					onBlur={(e) => addPOI.handleBlur(e)}
					onChange={(e) => addPOI.handleChange(e)}
					value={addPOI?.values.clientName || ""}
				/>
			</div>
			<label className="form-label text-capitalize mb-1">
				{trans("contact person info")}
			</label>
			<div className="poi-contact-person-info">
				<div className="row">
					<div className="col-lg-6">
						<Checkbox
							id="contactPerson.isCurrentUser"
							name="contactPerson.isCurrentUser"
							checked={actualUsers || false}
							onChange={async (e) => {
								const newValue = e.target.checked;

								setActualUsers(newValue);
								setUser(null);

								await addPOI?.setFieldTouched(
									"contactPerson.isCurrentUser",
									true
								);
								await addPOI?.setFieldValue(
									"contactPerson.isCurrentUser",
									newValue
								);

								// If unchecked → clear fields and reset touched
								if (!newValue) {
									addPOI?.setFieldValue("contactPerson.name", null);
									addPOI?.setFieldValue("contactPerson.phone", null);
									addPOI?.setFieldValue("contactPerson.email", null);

									addPOI?.setFieldTouched("contactPerson.name", false);
									addPOI?.setFieldTouched("contactPerson.phone", false);
									addPOI?.setFieldTouched("contactPerson.email", false);
								}
							}}
							className="form-label"
						>
							{trans("Exisiting customers")}
						</Checkbox>
					</div>
					{actualUsers && (
						<div className="col-lg-6">
							<Space className="w-100" style={{ width: "100%" }} size={0}>
								<Select
									placeholder={trans("Select User")}
									className="w-100"
									style={{ width: "100%" }}
									options={data?.data.map((i) => ({
										label: i?.name,
										value: i?.id,
									}))}
									value={
										addPOI?.values?.contactPerson?.isCurrentUser &&
										data?.data?.find(
											(u) => u?.name === addPOI?.values?.contactPerson?.name
										)?.id
									}
									onChange={async (id) => {
										const selectedUser = data?.data?.find((u) => u.id === id);
										setUser(selectedUser);
										addPOI?.setFieldTouched("contactPerson.name", true);
										addPOI?.setFieldValue(
											"contactPerson.name",
											selectedUser?.name
										);
										addPOI?.setFieldTouched("contactPerson.email", true);
										addPOI?.setFieldValue(
											"contactPerson.email",
											selectedUser?.email
										);
										addPOI?.setFieldTouched("contactPerson.phone", true);
										addPOI?.setFieldValue(
											"contactPerson.phone",
											selectedUser?.phoneNumber
										);
										await addPOI.validateForm();
										console.log("Selected user:", selectedUser);
									}}
								/>
							</Space>
						</div>
					)}
					<div className="col-lg-12">
						<Input
							title={trans("Name")}
							type="text"
							disabled={actualUsers}
							placeholder={trans("Enter contact name")}
							id="contactPerson.name"
							name="contactPerson.name"
							formstyle="form-input"
							onBlur={(e) => addPOI.handleBlur(e)}
							onChange={(e) => addPOI.handleChange(e)}
							value={addPOI?.values.contactPerson?.name || ""}
							errors={
								addPOI?.errors?.contactPerson?.name
									? addPOI?.errors?.contactPerson?.name
									: null
							}
							touched={
								addPOI?.touched.contactPerson?.name
									? addPOI?.touched.contactPerson?.name
									: null
							}
						/>
					</div>
					<div className="col-lg-6">
						<div className={`position-relative form-input`}>
							<label className="form-label">{trans("phone number")}</label>
							<div dir="ltr">
								{" "}
								<PhoneInput
									disabled={actualUsers}
									country={"ae"}
									id="contactPerson.phone"
									name="contactPerson.phone"
									inputClass="phone-input"
									containerClass="phone-input-container"
									countryCodeEditable={true}
									enableSearch={true}
									disableSearchIcon
									onBlur={addPOI.handleBlur}
									onChange={(value) =>
										addPOI.setFieldValue("contactPerson.phone", value)
									}
									value={addPOI?.values?.contactPerson?.phone || ""}
									errors={
										addPOI?.errors?.contactPerson?.phone
											? addPOI?.errors?.contactPerson.phone
											: null
									}
									touched={
										addPOI?.touched.contactPerson?.phone
											? addPOI?.touched?.contactPerson.phone
											: null
									}
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<Input
							title={trans("Email")}
							type="email"
							disabled={actualUsers}
							placeholder={trans("Enter contact email")}
							id="contactPerson.email"
							name="contactPerson.email"
							formstyle="form-input"
							onBlur={(e) => addPOI.handleBlur(e)}
							onChange={(e) => addPOI.handleChange(e)}
							errors={
								addPOI?.errors?.contactPerson?.email
									? addPOI?.errors?.contactPerson?.email
									: null
							}
							touched={
								addPOI?.touched.contactPerson?.email
									? addPOI?.touched.contactPerson?.email
									: null
							}
							value={addPOI?.values?.contactPerson?.email || ""}
						/>
					</div>
					<div className="validation">
						{addPOI?.errors?.contactPerson &&
							typeof addPOI.errors.contactPerson !== "object" &&
							!["name", "email", "phone"].some((key) =>
								addPOI.errors.contactPerson?.hasOwnProperty?.(key)
							) &&
							addPOI.errors.contactPerson}
					</div>
				</div>
			</div>
		</>
	);
}
